import dayjs from "dayjs";

export const createDate = (month?: number, day?: number) => {
    const date = dayjs()
        .add(month ?? 0, "month")
        .add(day ?? 0, "day")
        .hour(0)
        .minute(0)
        .second(0)
        .millisecond(0);
    const currentYear = date.year();
    const currentMonth = date.month() + 1;
    const currentDate = date.date();
    const currentLastDay = date.endOf("month").date();
    const currentFirstWeek = date.startOf("month").day();
    const currentDateInfo = `${currentYear}-${currentMonth.toString().padStart(2, "0")}-${currentDate.toString().padStart(2, "0")}`;
    const currentWeekdayNumber = date.day();

    return {
        currentObj: date,
        currentYear,
        currentMonth,
        currentDate,
        currentFirstWeek,
        currentLastDay,
        currentDateInfo,
        currentWeekdayNumber,
    };
};

export const handleDate = (date: string, handle?: number) => {
    const newDate = dayjs(date)
        .add(handle ?? 0, "day")
        .hour(0)
        .minute(0)
        .second(0)
        .millisecond(0);
    const newYear = newDate.year();
    const newMonth = newDate.month() + 1;
    const newDay = newDate.date();
    const newDateInfo = `${newYear}-${newMonth.toString().padStart(2, "0")}-${newDay.toString().padStart(2, "0")}`;

    return { newDateInfo };
};
